export default __webpack_public_path__ + "static/fsb-member-logo-colour-3c6f545473eddce950389318bb5c63a3.png";